import { connect } from "react-redux";
import GoLiveValet from "./goLiveValet";
import { bindActionCreators } from "redux";
import {
  valetGoLiveChecklist,
  postValetGoLive
} from "services/redux/installation/civilCheckList/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  valetGoLive: state.civilReducer.valetGoLive,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      valetGoLiveChecklist,
      getGateInfo,
      documentUploadUrl,
      postValetGoLive
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GoLiveValet);
